import React from "react";
import "./css/SidebarItem.scss";

interface SidebarItemProps {
  menu: {
    name: string;
    path: string;
    auth?: string[];
  };
  active?: boolean;
  hasSubmenu?: boolean;
  expanded?: boolean;
  userGroup: string | null;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ menu, active, hasSubmenu, expanded, userGroup }) => {
  if (menu.auth && (!userGroup || !menu.auth.includes(userGroup))) return null;

  return (
    <span className={`sidebar-item${active ? " is-active" : ""}`}>
      <span className="sidebar-item__marker" aria-hidden="true" />
      <span className="sidebar-item__label">{menu.name}</span>
      {hasSubmenu && <span className={`sidebar-item__chevron${expanded ? " is-expanded" : ""}`} aria-hidden="true">›</span>}
    </span>
  );
};

export default SidebarItem;
